<template>
  <el-cascader-panel
      ref="cascaderPanel"
      v-model="selectedValue"
      :options="options"
      :props="cascaderProps"
      class="d2-cascader-panel"
      @change="handleChange"
      @expand-change="expandChange"
  ></el-cascader-panel>
</template>
<script>
import { getLockReason } from '@/api/basic/customer'

export default {
  name: 'd2-container-cascader-panel',
  data () {
    return {
      selectedValue: [],
      options: [],
      cascaderProps: {
        checkStrictly: false,
        expandTrigger: 'click',
        value: 'id',
        label: 'reasonLabel'
      }
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    initMsg () {
      getLockReason().then(res => {
        if (res.code === 0) {
          this.options = res.data.map(item => this.removeEmptyChildren(item))
          console.log('this.options', this.options)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    removeEmptyChildren (node) {
      // 浅拷贝节点，避免直接修改原数据
      const newNode = { ...node }

      // 如果存在 children 且是数组
      if (newNode.children && Array.isArray(newNode.children)) {
        if (newNode.children.length === 0) {
          // 移除空 children
          delete newNode.children
        } else {
          // 递归处理子节点
          newNode.children = newNode.children.map(child => this.removeEmptyChildren(child))
        }
      }

      return newNode
    },
    // 通过 change 事件验证
    handleChange (val) {
      this.judgeIsComplete()
    },
    expandChange (val) {
      if (val.length === 1) {
        this.$emit('expandChange', val)
        if (val[0] === 3) {
          this.$emit('changeProject', true)
        } else {
          this.$emit('changeProject', false)
        }
      } else if (val.length === 2) {
        this.$emit('expandChange', val)
      }
    },
    judgeIsComplete () {
      const selectedNodes = this.$refs.cascaderPanel.getCheckedNodes()
      console.log('selectedNodes', selectedNodes)
      if (selectedNodes.length > 0) {
        const isComplete = selectedNodes.every(node => node.isLeaf)
        console.log('isComplete', isComplete)
        this.$emit('selectComplete', isComplete)
        this.$emit('change', this.selectedValue)
        // if (!isComplete) {
        //   this.$message.warning('请选择到最末级节点！')
        // }
      }
    }
  },
  watch: {
  },
  mounted () {
    this.initMsg()
  }
}
</script>

<style lang="scss" scoped>
  .d2-cascader-panel::v-deep {
    display: flex;
    flex-direction: column;
    border: none;
    /* 选中状态样式 */
    .el-cascader-node.is-active {
      color: #409eff;
      background: #f5f7fa;
    }
    .el-cascader-menu__list {
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      border-bottom: 1px solid #d7d7d7;
    }
    /* 整体容器改为垂直布局 */
    .el-cascader-menu {
      border: none;
    }
    /* 每一级菜单项样式 */
    .el-cascader-node {
      border-radius: .375rem;
      border: 1px solid rgba(0, 0, 0, 1);
      margin: 10px 20px;
    }
    .el-cascader-node:hover {
      border-color: #409eff;
      color: #409eff;
    }
    /* 选中状态样式 */
    .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
      border: 2px solid #409eff;
    }
    .el-cascader-menu:first-child {
      .el-cascader-node {
        background: #f4f4f5;
        border: 1px solid #d3d4d6;
        color: #606266;
        border-radius: 4px;
        padding-right: 30px;
        margin: 20px 20px 10px 20px;
      }
      .el-cascader-node:hover {
        background: #ecf5ff;
        border-color: #e6e2ff;
        color: #409eff;
        border-radius: 4px;
      }
      /* 选中状态样式 */
      .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
        color: #FFFFFF;
        background-color: #409eff;
        border-color: #409eff;
        box-shadow: -1px 0 0 0 #409eff;
      }
    }

    /* 子菜单展开方向 - 关键修改 */
    .el-cascader-menu__wrap {
      height: auto;
    }

    .el-cascader-node__postfix {
      //display: none;
    }

    /* 箭头图标旋转方向 */
    .el-icon-arrow-right {
      transform: rotate(90deg); /* 默认箭头朝右 */
      &::before {
        content: "\e6e0"; /* 使用向下箭头图标（需匹配图标库） */
      }
    }
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-cascader-panel/index.vue"
}
</vue-filename-injector>
